import { render } from "./QuickView.vue?vue&type=template&id=67496bf8&scoped=true"
import script from "./QuickView.vue?vue&type=script&lang=js"
export * from "./QuickView.vue?vue&type=script&lang=js"

import "./QuickView.vue?vue&type=style&index=0&id=67496bf8&scoped=scoped&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67496bf8"]])

export default __exports__